import { Heading } from "@chakra-ui/react";

export default function FAQLanguageTitle({ lang, fontSize }) {
  const headingProps = fontSize ? { fontSize } : {};

  if (lang === "hi") {
    return <Heading as="h1" {...headingProps}>अक्सर पूछे जाने वाले प्रश्न</Heading>;
  }
  if (lang === "mr") {
    return <Heading as="h1" {...headingProps}>सतत विचारले जाणारे प्रश्न</Heading>;
  }
  if (lang === "gu") {
    return <Heading as="h1" {...headingProps}>વારંવાર પૂછાતા પ્રશ્નો</Heading>;
  }
  if (lang === "id") {
    return <Heading as="h1" {...headingProps}>Pertanyaan yang Sering Diajukan</Heading>;
  }
  return <Heading as="h1" {...headingProps}>Frequently asked questions</Heading>;
}
